export default "__VITE_ASSET__v1PYWMg$__"